export default __webpack_public_path__ + "static/disaster-recovery-response-938c61115e237ab286f9c5fd3da99396.png";